import React from "react";
import LandingContainer from "../containers/landing-container";

export default class LandingPage extends React.Component {
  render() {
    return (
      <main className="landing-page">
        <LandingContainer />
      </main>
    );
  }
}
